exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".reinsurance ul[data-v-cb799500]{list-style:none}", ""]);

